<template>
  <b-row class="my-3" align-v="center">
    <b-col :sm="labelWidth" class="text-left">
      <label class="mb-0 align-middle">{{this.label}}</label>
    </b-col>
    <b-col :sm="inputWidth">
      <input-tag class="FITInput" v-bind:class="{disabled:disabled}" :tags.sync="value" :limit='this.limit' :placeholder="this.placeholder" :readOnly="this.disabled" @update:tags="addTag"></input-tag>
    </b-col>
  </b-row>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'
import InputTag from 'vue-input-tag'
export default {
  name: 'FITInputTag',
  components: {
    InputTag
  },
  props: {
    label: String,
    placeholder: String,
    disabled: Boolean,
    width: {
      type: Number,
      default: 10
    },
    limit: String
  },
  data() {
    return {
      inputWidth: this.width,
      value: [],
    }
  },
  mounted() {
    this.labelCheck(this.label);
  },

  computed: {
    labelWidth() {
      return 12 - this.inputWidth;
    }
  },
  methods: {
    labelCheck(label) {
      if (!label) {
        this.inputWidth = 12;
      }
    },
    addTag(event) {
      // console.log(this.value);
      this.$emit('input', this.value);
    }
  }
}

</script>
<style type="text/css">
div.vue-input-tag-wrapper .new-tag{
    margin:0px !important;
    line-height: 1.5;
    font-size: 0.875rem;
    padding: 0px !important;
}
div.vue-input-tag-wrapper {
  border: 1px solid #CDCDCD !important;
  border-radius: 0.25rem; 
    padding:0.375rem 0.75rem !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Form/FITInputTag.vue